import { Directive, ElementRef, inject, Input, type OnInit } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { UserRolesIds } from '@models';

@Directive({
  selector: '[avsSuperAdminRoleFilter]',
  standalone: true,
})
export class SuperAdminRoleFilterDirective implements OnInit {
  @Input() isManagingClient: boolean | undefined;

  private el = inject(ElementRef);
  private matOption = inject(MatOption);

  ngOnInit(): void {
    if (this.matOption.value !== UserRolesIds.SuperAdmin) return;
    if (!this.isManagingClient) {
      this.el.nativeElement.style.display = 'none';
    }
  }
}
